/**
 * Knowledge Product Cards - Client-Side Enrichment
 *
 * Finds product links on knowledge pages (stone encyclopedia, problem guides,
 * care guides, landing pages) and upgrades them from plain text links to rich
 * mini-cards with image, title, and price using window.LithofinProductNames.
 */
(function () {
  var nameMap = window.LithofinProductNames;
  if (!nameMap) return;

  // Find all product links marked with data-product-name or class kp-product-link
  var links = document.querySelectorAll('a[data-product-name], a.kp-product-link');
  if (!links.length) return;

  links.forEach(function (link) {
    var productName = link.getAttribute('data-product-name') || link.textContent.trim();
    var match = nameMap[productName.toLowerCase()];

    if (!match) {
      // Try partial match: strip "Lithofin " prefix
      var stripped = productName.replace(/^Lithofin\s+/i, '').toLowerCase();
      for (var key in nameMap) {
        if (key.indexOf(stripped) !== -1 || stripped.indexOf(key.replace('lithofin ', '')) !== -1) {
          match = nameMap[key];
          break;
        }
      }
    }

    if (!match) return; // Keep original link as fallback

    // Update href to direct product URL
    link.href = match.url;
    link.className = 'kp-product-card';
    link.removeAttribute('data-product-name');

    // Build card HTML
    var html = '';
    if (match.image) {
      html += '<img src="' + match.image + '" alt="' + match.title + '" class="kp-product-card__img" width="80" height="80" loading="lazy">';
    }
    html += '<span class="kp-product-card__info">';
    html += '<span class="kp-product-card__title">' + match.title + '</span>';
    if (match.price) {
      html += '<span class="kp-product-card__price">' + match.price + '</span>';
    }
    html += '</span>';

    link.innerHTML = html;
  });

  // Also enrich bare product lists (ul inside .product-category, .products-needed)
  var productLists = document.querySelectorAll('.product-category ul, .products-needed ul');
  productLists.forEach(function (ul) {
    var items = ul.querySelectorAll('li');
    if (!items.length) return;

    // Convert list to card grid
    var grid = document.createElement('div');
    grid.className = 'kp-product-grid';

    items.forEach(function (li) {
      var existingLink = li.querySelector('a.kp-product-card');
      if (existingLink) {
        grid.appendChild(existingLink.cloneNode(true));
        return;
      }

      // Find plain links not yet enriched
      var plainLink = li.querySelector('a:not(.kp-product-card)');
      if (!plainLink) return;

      var name = plainLink.getAttribute('data-product-name') || plainLink.textContent.trim();
      var m = nameMap[name.toLowerCase()];

      if (!m) {
        var s = name.replace(/^Lithofin\s+/i, '').toLowerCase();
        for (var k in nameMap) {
          if (k.indexOf(s) !== -1 || s.indexOf(k.replace('lithofin ', '')) !== -1) {
            m = nameMap[k];
            break;
          }
        }
      }

      if (m) {
        var card = document.createElement('a');
        card.href = m.url;
        card.className = 'kp-product-card';
        var cardHtml = '';
        if (m.image) {
          cardHtml += '<img src="' + m.image + '" alt="' + m.title + '" class="kp-product-card__img" width="80" height="80" loading="lazy">';
        }
        cardHtml += '<span class="kp-product-card__info">';
        cardHtml += '<span class="kp-product-card__title">' + m.title + '</span>';
        if (m.price) {
          cardHtml += '<span class="kp-product-card__price">' + m.price + '</span>';
        }
        cardHtml += '</span>';
        card.innerHTML = cardHtml;
        grid.appendChild(card);
      } else {
        // Keep original as plain link
        grid.appendChild(li.cloneNode(true));
      }
    });

    if (grid.children.length > 0) {
      ul.parentNode.replaceChild(grid, ul);
    }
  });
})();
